/**
 * ノード本文の見た目を、本文の書き出しから決める。
 *
 * 見出し・引用・水平線は、描画した HTML ではなく元のテキストで判定する。
 * 編集中はフォーカスで生テキストに戻すため、HTML から判定すると
 * 編集の途中で見た目が飛んでしまうから。
 */

import { isMarkdownHorizontalRule } from './text-format.js';

export function updateNodeHeaderStyle(textEl: HTMLElement | null, content: string) {
  if (!textEl) {
    return;
  }

  const headerMatch = /^(#{1,6})\s/.exec(content || '');
  const headingLevel = headerMatch?.[1].length || 0;
  textEl.classList.toggle('is-markdown-header', headerMatch !== null);
  textEl.classList.toggle('is-markdown-title', headingLevel === 1);
  textEl.classList.toggle('is-markdown-subtitle', headingLevel === 2);

  textEl.classList.toggle('is-markdown-blockquote', /^[>＞]\s/.test(content || ''));
  textEl.classList.toggle('is-markdown-horizontal-rule', isMarkdownHorizontalRule(content));
}
